<template>
    <div>
        <Navbar Title="Projects"/>

        <div class="container">
            <h1 class="pb-3 pt-2 border-bottom mb-3" style="color: black;font-size:35px;font-family: 'Roboto';font-weight:300; margin:0">Previous Projects</h1>
            
            <ul class="nav nav-tabs mb-3" id="myTab" role="tablist" >
            <li class="nav-item" role="presentation" style="cursor:pointer">
                <a class="nav-link active" data-bs-toggle="tab"  role="tab" @click="display=info">All</a>
            </li>
            <li class="nav-item" role="presentation" style="cursor:pointer">
                <a class="nav-link" data-bs-toggle="tab" role="tab" @click="active('web')">Web-development</a>
            </li>
            <li class="nav-item" role="presentation" style="cursor:pointer">
                <a class="nav-link" data-bs-toggle="tab" role="tab" @click="active('game')">Games</a>
            </li>
            <li class="nav-item" role="presentation" style="cursor:pointer">
                <a class="nav-link" data-bs-toggle="tab" role="tab" @click="active('art')">Graphics</a>
            </li>
            <li class="nav-item" role="presentation" style="cursor:pointer">
                <a class="nav-link" data-bs-toggle="tab" role="tab" @click="active('data')">Data scraping, analysis</a>
            </li>
            </ul>
            
            
            
            <div class="row justify-content-center">
                <div class="col-8 col-md-4 col-lg-3 " v-for="(el , index) in display" :key="index" style="margin-bottom:20px">
                  <div class="card" style="height:100%;">
                    <img v-bind:src="el.image" class="card-img-top">
                    <div class="card-body" style="height: auto;">
                        <h1 class="card-title" style="color: black;font-size: 25px;font-family: 'Roboto';font-weight:100;">{{el.title}}</h1>
                      <p class="card-text" style="font-size: small;margin:0px;font-family: 'Roboto';font-weight:400">{{el.desc}}</p><br>
                      <div class="cloumns" >
                        <div class="column">
                            <a v-if=" el.route" v-bind:href="el.route" v-bind:target="el.target"  class="btn btn-outline-primary" style="margin:10px;">View Project</a>
                        </div>
                        <div class="column"><a v-if="el.code" v-bind:href="el.code" target="_blank" class="btn btn-outline-info" style="margin:10px">See the code</a></div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

        </div>
        

    </div>
</template>

<script>
import db from '@/firebase/init'
import Navbar from '@/components/Navbar'
export default {
    name: 'Projects',
    components: {
        Navbar,
    },
    data(){
        return{
            info:[],
            display:[],
        }
    },
    methods:{
        active(val){
            this.display=this.info.filter(el=>{
                if(val!="all")
                    return el.tag==val
            })

        }
    },
    created()
    {
        db.collection("Projects").get().then(snapshot => {
            snapshot.forEach(element => {
                let task = element.data();
                task.id = element.id;
                this.info.push(task)
                this.display.push(task)
                // console.log(this.info)
            });
        })
    }
}
</script>

<style scoped>

</style>